const statementsNL = {
    "view": {
        "table": {
            "title": "Uw verklaringenlijst",
            "column": {
                "type": "Type",
                "year": "Jaar",
                "month": "Maand",
                "issue_year": "Uitg. Jaar",
                "issue_month": "Uitg. Maand",
                "description": "Beschrijving",
                "amount": "Bedrag",
                "status": "Status",
                "details": "Details",
                "overview": "Overzicht"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "label": {
                "status_open": "Open",
                "status_paid": "Betaald",
                "type_licensing": "Licenties",
                "type_regular": "Regulier",
                "type_audio_mastering_services": "Audio Mastering - Diensten",
                "type_vinyl_earnings": "Vinyl Verdiensten",
                "type_offset": "Compensatie",
                "type_not_known": "Niet Bekend",
                "month_january": "Januari",
                "month_february": "Februari",
                "month_march": "Maart",
                "month_april": "April",
                "month_may": "Mei",
                "month_june": "Juni",
                "month_july": "Juli",
                "month_august": "Augustus",
                "month_september": "September",
                "month_october": "Oktober",
                "month_november": "November",
                "month_december": "December"
            },
            "button": {
                "download": "Downloaden",
                "exportCsv": "Exporteer CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Uw huidige abonnementsplan ondersteunt deze functie niet. Gelieve uw abonnementsplan te <1>upgraden</1> om deze functie te gebruiken.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve uw abonnement te <1>hervatten</1> om deze functie te gebruiken.",
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        }
    }
};

export default statementsNL;